/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const optimism_chain_about = () => `Optimism provides a Layer 2 scaling fix for Ethereum, greatly boosting its scalability and cutting down on gas fees. It maintains robust security measures and guarantees a smooth development experience. Through Optimistic Rollups, it enables swift transaction processing, positioning Ethereum as a viable option for deploying intricate and interactive applications.`
